import merge from '../functions/merge'

export default {
	entity() {
		return merge({}, {
			name: '',
			phone: '',
			fax: '',
			email: '',
			address: '',
			zip: '',
			city: '',
			country: '',
			roles: {},
			numbers: [],
			rep_contact_id: null,
			invoice_contact_id: null,
			pack_unlimited: false,
			pack_remarks: '',
			details: '',
			info: '',
			invoice_text: '',
			email_invoice: false,
			blacklisted: '',
			_embedded: {
				invoice_contact: {
					name: '',
					address: '',
					zip: '',
					city: ''
				},
				prices: []
			}
		});
	},
	save(axios, entity) {
		var self = this;

		return new Promise(function (resolve) {
			if (entity.id) {
				axios
					.put('/contacts/' + entity.id + '/', entity)
					.then(function (r) {
						resolve(merge(self.entity(), r.data));
					}, function () {
						
					});
			} else {
				axios
					.post('/contacts/', entity)
					.then(function (r) {
						resolve(merge(self.entity(), r.data));
					}, function () {
						
					});
			}
		});
	},
	read(axios, id) {
		var self = this;

		return new Promise(function (resolve) {
			axios
				.get('/contacts/' + id + '/')
				.then(function (r) {
					resolve(merge(self.entity(), r.data));
				}, function () {
					
				});
		});
	},
	delete(axios, id) {
		return new Promise(function (resolve) {
			axios
				.delete('/contacts/' + id + '/')
				.then(function () {
					resolve(true);
				}, function () {
					
				});
		});
	}
};